

function setTitle(val: string) {
  document.title = val
}


export default {
  setTitle,
}